module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __donate __limited-edu __limited-edu--2021"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10"
  }, [_c('div', {
    staticClass: "product product--inline"
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "radius block shadow"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": true,
      "product": _vm.product,
      "classes": "col-1-5"
    },
    model: {
      value: (_vm.product.price),
      callback: function($$v) {
        _vm.$set(_vm.product, "price", $$v)
      },
      expression: "product.price"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__wrapper mt-15 mb-15"
  }, [(_vm.product.price) ? _c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.rewardTitleText))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("กรุณาเลือกขนาดเสื้อ และระบุเลขที่ผลงาน")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    staticClass: "slide-down-wrapper",
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_c('div', {
    staticClass: "form__section block-third slide-down-item"
  }, [_c('div', {
    staticClass: "text-right mb-10"
  }, [_vm._v("\n                        จำนวนเสื้อ "), _c('strong', {
    staticClass: "reward-count"
  }, [_vm._v(_vm._s(_vm.selectedRewardCount) + "/" + _vm._s(_vm.rewardCount))])]), _vm._v(" "), _vm._l((_vm.rewards), function(reward, i) {
    return _c('div', {
      key: i,
      staticClass: "reward-item",
      class: {
        'reward-item-error': reward.error
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward.size),
        expression: "reward.size"
      }],
      staticClass: "custom-select select-change",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(reward, "size", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.sizeOptions), function(sizeOption) {
      return _c('option', {
        key: sizeOption.text,
        domProps: {
          "value": sizeOption.text
        }
      }, [_vm._v("\n                              " + _vm._s(sizeOption.text) + "\n                            ")])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "size-description"
    }, [_vm._v("\n                            " + _vm._s(_vm.getSizeDescription(reward.size)) + "\n                          ")]), _vm._v(" "), _c('button', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeReward(i)
        }
      }
    }, [_vm._v("\n                            ลบ\n                          ")])]), _vm._v(" "), _c('div', {}, [_c('label', {
      staticClass: "d-flex align-items-center"
    }, [_vm._v("\n                            เลขที่ผลงาน "), _c('span', {
      staticStyle: {
        "color": "#EA2B2B"
      }
    }, [_vm._v("*")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward.code),
        expression: "reward.code"
      }],
      ref: "inputCode",
      refInFor: true,
      staticClass: "code-input",
      class: {
        error: reward.error
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (reward.code)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(reward, "code", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "small alert--remark alert--info"
    }, [_c('span', {
      staticStyle: {
        "color": "#EA2B2B"
      }
    }, [_vm._v("*")]), _vm._v(" เลขที่ผลงานจากเวปออกแบบเสื้อ "), _c('a', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "href": "https://www.limitededucation.org/shirt",
        "target": "_blank"
      }
    }, [_vm._v("www.limitededucation.org/shirt")])]), _vm._v(" "), (reward.error) ? _c('div', {
      staticClass: "alert alert--error mt-5"
    }, [_vm._v("\n                            " + _vm._s(reward.error) + "\n                          ")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.selectedRewardCount < _vm.rewardCount) ? _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAddReward),
      expression: "selectedAddReward"
    }],
    staticClass: "custom-select select-add",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAddReward = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onSelectSize]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("เลือกขนาดเสื้อตัวที่ " + _vm._s(_vm.selectedRewardCount + 1))]), _vm._v(" "), _vm._l((_vm.sizeOptions), function(sizeOption) {
    return _c('option', {
      key: sizeOption.text,
      domProps: {
        "value": sizeOption.text
      }
    }, [_vm._v("\n                            " + _vm._s(sizeOption.text) + " (" + _vm._s(sizeOption.description) + ")\n                          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error mt-5"
  }, [_vm._v("\n                        " + _vm._s(_vm.error.rewardConfigSize) + "\n                      ")]) : _vm._e()], 2)])])], 1) : _vm._e()]), _vm._v(" "), _c('donor-info', {
    staticClass: "pt-15",
    model: {
      value: (_vm.attributes.info.name),
      callback: function($$v) {
        _vm.$set(_vm.attributes.info, "name", $$v)
      },
      expression: "attributes.info.name"
    }
  }), _vm._v(" "), _c('page-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.attributes.page),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "page", $$v)
      },
      expression: "attributes.page"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "product": _vm.product,
      "attributes": _vm.attributes,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn--purple btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmReward.apply(null, arguments)
      }
    }
  }, [_vm._v("บริจาค")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-header"
  }, [_c('div', {
    staticClass: "col-md-push-3 col-md-6"
  }, [_c('h1', {
    staticClass: "text-center mb-20",
    attrs: {
      "data-v-1f20e9ef": ""
    }
  }, [_c('img', {
    staticClass: "pd-15 ma-auto d-block",
    attrs: {
      "src": "/static/img/limited-edu/logo-lmt-edu@2x.png",
      "width": "200px",
      "alt": "Limited Education 2021"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb18d39","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/limited-education-2021.vue
// module id = 1115
// module chunks = 0